<template>
  <button id="NUMBER_4" name="4" class="btn num-btn" data-vcode="NUMBER_4" aria-label="4 GHI">
    <div class="digit">4</div>
    <div class="letters">GHI</div>
  </button>
</template>
<script>
export default {};
</script>
